<template>
    <div class="dashboard-project">
        <div :class="['dashboard-project__content', {'is-active': isOpen}]">
            <div class="dashboard-project__content-text">
                <div v-if="project.name"
                     class="dashboard-project__content-name">
                    {{ project.name }}
                </div>
                <div v-if="project.address"
                     class="dashboard-project__content-address">
                    {{ project.address }}
                </div>
                <div v-if="project.metro"
                     class="dashboard-project__content-metro">
                    {{ project.metro }}
                </div>
                <button class="dashboard-project__content-more"
                        @click="toggleProjectInfo">
                    <IconPlusBlue />
                </button>
            </div>
            <div class="dashboard-project__content-info">
                <div v-if="price"
                     class="dashboard-project__content-price">
                    Цена от <span v-html="price" /> ₽
                </div>
                <template v-if="project.queue && project.queue.length">
                    <div class="dashboard-project__content-label">
                        Ввод в эксплуатацию
                    </div>
                    <ul class="dashboard-project__content-queue">
                        <li v-for="(item, key) in project.queue"
                            :key="key"
                            v-html="item" />
                    </ul>
                </template>
                <STBaseButton v-if="project.link"
                              text="Сайт проекта"
                              :href="project.link"
                              :is-link="true"
                              :blank="true"
                              icon-after="IconArrowLink"
                              icon-after-modify="icon-stroke icon_color_blue"
                              modify="button_theme_reset dashboard-project__content-link" />
            </div>
            <div class="dashboard-project__content-image">
                <img v-if="project.image"
                     :src="project.image"
                     :alt="project.name">
            </div>
        </div>
    </div>
</template>

<script>
import IconPlusBlue from '@/components/Icons/PlusBlue';
import {mapGetters} from 'vuex';

export default {
    name: 'DashboardProject',

    components: {
        IconPlusBlue
    },

    props: {
        project: {
            type: Object,
            default() {
                return {
                    name   : '',
                    address: '',
                    metro  : '',
                    image  : '',
                    price  : '',
                    queue  : [],
                    link   : ''
                };
            }
        },
        isPurchased: Boolean
    },

    data() {
        return {
            isOpen: false, // открыта ли информация о проекте
            price : null
        };
    },

    computed: {
        ...mapGetters({
            activeType: 'parametric/GET_ACTIVE_TYPE'
        })
    },

    mounted() {
        // Устанавливаем цену в зависимости от категории
        if (this.activeType === 'flats') {
            this.price = this.project.price_min_flats;
        } else if (this.activeType === 'commerce') {
            this.price = this.project.price_min_offices;
        }
    },

    methods: {
        /**
         * Показавыет/скрывает информацию о проекте
         */
        toggleProjectInfo() {
            this.isOpen = !this.isOpen;
        }
    }
};
</script>

<style lang="scss">
@import "ParametricProject";
</style>
